/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiConversionStateLookupType;
(function (ApiConversionStateLookupType) {
    ApiConversionStateLookupType["EQUALS"] = "CONVERSION_STATE_EQUALS";
    ApiConversionStateLookupType["REGEX"] = "CONVERSION_STATE_REGEX";
    ApiConversionStateLookupType["CONTAINS"] = "CONVERSION_STATE_CONTAINS";
})(ApiConversionStateLookupType || (ApiConversionStateLookupType = {}));
export function ApiConversionStateLookupTypeFromJSON(json) {
    return ApiConversionStateLookupTypeFromJSONTyped(json, false);
}
export function ApiConversionStateLookupTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiConversionStateLookupTypeToJSON(value) {
    return value;
}
